/**
 * Настройки нотификаций рекрутера (TASKNEIROKLYUCH-647).
 * Endpoint: GET/PUT /api/v1/account/notification-preferences.
 */

import { apiService } from './apiService';
import type {
	AccountNotificationPreferencesPayload,
	AccountNotificationFunnelStatus,
} from '../../generated-src/client/account-notifications/api';

export type NotificationFunnelStatus = AccountNotificationFunnelStatus;

export type NotificationPreferences = AccountNotificationPreferencesPayload;

export const FUNNEL_LABELS: Record<NotificationFunnelStatus, string> = {
	PROBLEM: 'Статус диалога: проблема',
	APPROVED: 'Статус кандидата: одобрен',
	FINALIST: 'Статус кандидата: финалист',
	OVERDUE: 'Статус диалога: просрочен',
	WITH_REPLY: 'Статус диалога: с ответом',
	REJECTED: 'Статус кандидата: отклонён',
	DECLINED: 'Статус кандидата: отказался',
	NO_REPLY: 'Статус диалога: без ответа',
};

export const ALL_FUNNEL_STATUSES: NotificationFunnelStatus[] = [
	'PROBLEM',
	'APPROVED',
	'FINALIST',
	'OVERDUE',
	'WITH_REPLY',
	'REJECTED',
	'DECLINED',
	'NO_REPLY',
];

export async function getNotificationPreferences(): Promise<NotificationPreferences> {
	const client = apiService.getAuthenticatedClient();
	const response = await client.accountNotificationPreferences.getNotificationPreferences();
	return response.data;
}

export async function updateNotificationPreferences(
	prefs: NotificationPreferences,
): Promise<NotificationPreferences> {
	const client = apiService.getAuthenticatedClient();
	const response = await client.accountNotificationPreferences.updateNotificationPreferences(prefs);
	return response.data;
}
